import { render, staticRenderFns } from "./BottomRightAttacher.vue?vue&type=template&id=5ae3bc96&"
import script from "./BottomRightAttacher.vue?vue&type=script&lang=js&"
export * from "./BottomRightAttacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports